import React from "react";
import { createBrowserRouter, Outlet, redirect } from "react-router-dom";

// Pages
import AdminAccountPage from "../pages/Admin/Account/AccountPage";
import AdminCreateCompanyPage from "../pages/Admin/Company/CreateCompanyPage";
import AdminUpdateCompanyPage from "../pages/Admin/Company/UpdateCompanyPage";
import AdminUpdateCompanyServicesPage from "../pages/Admin/Company/UpdateCompanyServicesPage";
import AdminEmployeeDetailsPage from "../pages/Admin/Employees/EmployeeDetailsPage";
import AdminEmployeePage from "../pages/Admin/Employees/EmployeesPage";
import AdminManageAdminsPage from "../pages/Admin/Employees/ManageAdminsPage";
import AdminJobHistoryDetailsPage from "../pages/Admin/JobHistory/JobHistoryDetailsPage";
import AdminJobHistoryPage from "../pages/Admin/JobHistory/JobHistoryPage";
import AdminBulkImportJobs from "../pages/Admin/Jobs/BulkImportJobs";
import AdminJobsPage from "../pages/Admin/Jobs/JobsPage";
import SiteMapIndex from "../pages/Admin/Jobs/SiteMap/Index";
import SiteMapExportPage from "../pages/Admin/Jobs/SiteMap/ExportPage";
import AdminMaterialsPage from "../pages/Admin/Materials/MaterialsPage";
import AdminReportsPage from "../pages/Admin/Reports/ReportsPage";
import ServiceStatusPage from "../pages/Admin/JobHistory/ServiceStatusPage";
import AdminTimeClockPageWrapper from "../pages/Admin/TimeClock/TimeClockPageWrapper";
import TimeRecordPage from "../pages/Admin/TimeClock/TimeRecordPage";
import AboutPage from "../pages/LandingPage/AboutPage";
import AdminLoginPage from "../pages/LandingPage/AdminLoginPage";
import HomePage from "../pages/LandingPage/HomePage";
import SnowScapeAdmin from "../pages/Developer/SnowScapeAdmin";
import PickAProperty from "../pages/Admin/Jobs/PickAProperty";
import DebugPage from "../pages/Admin/Misc/DebugPage";

import AdminWrapper from "../pages/Admin/AdminWrapper";
import ActiveRouteDetailsPage from "../pages/Admin/Routes/ActiveRouteDetails";
import ActiveRoutesPage from "../pages/Admin/Routes/ActiveRoutes";
import ActiveRoutesMapRouteDetail from "../components/Maps/ActiveRoutes/RouteDetail";
import ActiveRoutesMapRoutePropertyDetail from "../components/Maps/ActiveRoutes/RoutePropertyDetail";
import CrewDetail from "../components/Maps/ActiveRoutes/CrewDetail";
import AdminCreateRoutePage from "../pages/Admin/Routes/CreateRoutePage";
import AdminRoutesPage from "../pages/Admin/Routes/RoutesPage";
import AdminUpdateRoutePage from "../pages/Admin/Routes/UpdateRoutePage";
import CreateFirstCompany from "../pages/Auth/CreateFirstCompany";
import GetStartedPage from "../pages/Auth/GetStartedPage";
import DeveloperBroadcastPushNotification from "../pages/Developer/BroadcastPushNotification";
import ErrorPage from "../pages/ErrorPage";
import ContactUsPage from "../pages/LandingPage/ContactUsPage";
import DocsPage from "../pages/LandingPage/DocsPage";
import FAQPage from "../pages/LandingPage/FAQPage";
import FeaturesPage from "../pages/LandingPage/FeaturesPage";
// import HomePage from "../pages/LandingPage/HomePage";
import LandingPage from "../pages/LandingPage/LandingPage";
import PricingPage from "../pages/LandingPage/PricingPage";
import QuotePage from "../pages/LandingPage/QuotePage";
import CompaniesPage from "../pages/Admin/Company/CompaniesPage";
import Terms from "../pages/LandingPage/Terms";

// New Landing Page

// Routing
import PrivateRoutes from "./PrivateRoutes";
import ProfileSettingsPage from "../pages/Settings/ProfileSettingsPage";
import AccountPage from "../pages/Admin/Account/AccountPage";
import DeactivateCompanyPage from "../pages/LandingPage/Docs/DeactivateCompanyPage";
import SignUpLayout from "../pages/SignUp/SignUpLayout";
import SignUpPage from "../pages/SignUp/SignUpPage";
import SnowAuthPage from "../pages/SignUp/SnowAuth/SnowAuthPage";
import VerifyCodePage from "../pages/SignUp/SnowAuth/VerifyCodePage";
import SignOutPage from "../pages/SignUp/SnowAuth/SignOutPage";
// import PaymentPage from "../pages/SignUp/PaymentPage";
import DashboardPage from "../pages/Admin/Dashboard/DashboardPage";
import StripeSuccessPage from "../pages/SignUp/StripeSuccessPage";
import StripeCancelPage from "../pages/SignUp/StripeCancelPage";
import NewEmployeeInstructionsPage from "../pages/Admin/Employees/NewEmployeeInstructionsPage";
import InstallInstructions from "../pages/LandingPage/InstallInstructions";
import SubscriptionPaywallV2 from "../components/Stripe/SubscriptionPaywallV2";
import AddRoute from "../pages/Admin/Routes/RoutePage/Routes/AddRoute";
import PreviewRoute from "../pages/Admin/Routes/RoutePage/Routes/PreviewRoute";
import IndexRoute from "../pages/Admin/Routes/RoutePage/Routes/IndexRoute";
import OptimizeRoute from "../pages/Admin/Routes/RoutePage/Routes/OptimizeRoute";
import ReferTerms from "../pages/LandingPage/ReferTerms";
import CancelPage from "../pages/Admin/Account/CancelPage";
import EmbedLayout from "../pages/SignUp/EmbedLayout";
import ActiveRoutesEmbedded from "../pages/Admin/Routes/ActiveRoutesEmbedded";
import Sidepanel from "../components/Maps/ActiveRoutes/ui/sidepanel";
import ActiveRouteDataLayer from "../components/Maps/ActiveRoutes/ActiveRouteDataLayer";
import ActiveRoutesBaseLayer from "../components/Maps/ActiveRoutes/BaseLayer";
import OverwritingContent from "../pages/Admin/Routes/OverwritingContent";
import SiteMapHazardPage from "../pages/Admin/Jobs/SiteMap/Edit/SiteMapHazardPage";
import SiteMapArrowPage from "../pages/Admin/Jobs/SiteMap/Edit/SiteMapArrowPage";
import SiteMapSurfacePage from "../pages/Admin/Jobs/SiteMap/SurfacePage";
import SiteMapTextPage from "../pages/Admin/Jobs/SiteMap/Edit/SiteMapTextPage";
import SiteMapEditPage from "../pages/Admin/Jobs/SiteMap/Edit";
import RenderSiteMap from "../components/SiteMap/RenderSiteMap";
import SiteMapDefault from "../pages/Admin/Jobs/SiteMap/Default";
import SiteMapBoundaryPage from "../pages/Admin/Jobs/SiteMap/Edit/SiteMapBoundaryPage";
import SiteMapSetupBoundaryPage from "../pages/Admin/Jobs/SiteMap/Edit/SiteMapSetupBoundaryPage";
import SiteMapEditIndex from "../pages/Admin/Jobs/SiteMap/Edit/Index";
import EditJobPage from "../pages/Admin/Jobs/EditJobPage";
import BulkEditJobsPage from "../pages/Admin/Jobs/BulkEditJobsPage";
import RequireAppVersion from "../components/RequireAppVersion";
import ShareJobsPage from "../pages/Admin/Jobs/ShareJobsPage";
import MergeJobsPage from "../pages/Admin/Jobs/MergeJobsPage";
import DeviceSettingsPage from "../pages/LandingPage/Docs/DeviceSettings";

const router = createBrowserRouter([
  {
    path: "/",
    element: <LandingPage />,
    errorElement: <ErrorPage />,
    children: [
      {
        path: "/",
        element: <HomePage />,
      },
      {
        path: "/about",
        element: <AboutPage />,
      },
      {
        path: "/contact",
        element: <ContactUsPage />,
      },
      {
        path: "/pricing",
        element: <PricingPage />,
      },
      {
        path: "/pricing/quote",
        element: <QuotePage />,
      },
      {
        path: "/features",
        element: <FeaturesPage />,
      },
      {
        path: "/faq",
        element: <FAQPage />,
      },
      {
        path: "/docs",
        element: <DocsPage />,
      },
      {
        path: "/docs/guides/deactivate-company",
        element: <DeactivateCompanyPage />,
      },
      {
        path: "/docs/guides/device-settings",
        element: <DeviceSettingsPage />,
      },
      {
        path: "/admin-login",
        element: <AdminLoginPage />,
      },
      {
        path: "/get-started",
        element: <GetStartedPage />,
      },
      {
        path: "/create-first-company",
        element: <CreateFirstCompany />,
      },
      {
        path: "/install",
        element: <InstallInstructions />,
      },
      {
        path: "/terms",
        element: <Terms />,
      },
      {
        path: "/refer-a-friend",
        element: <ReferTerms />,
      },
    ],
  },
  {
    path: "/sign-up",
    element: <SignUpLayout />,
    errorElement: <ErrorPage />,
    children: [
      {
        path: "/sign-up",
        element: <SignUpPage />,
      },
      {
        path: "/sign-up/payment-success",
        element: <StripeSuccessPage />,
      },
      {
        path: "/sign-up/payment-cancel",
        element: <StripeCancelPage />,
      },
      // {
      //   path: "/sign-up/payment",
      //   element: <PaymentPage />,
      // },
    ],
  },
  {
    path: "/login/v2",
    element: <SignUpLayout />,
    errorElement: <ErrorPage />,
    children: [
      {
        path: "/login/v2",
        element: <SnowAuthPage />,
      },
      {
        path: "/login/v2/verify",
        element: <VerifyCodePage />,
      },
      {
        path: "/login/v2/sign-out",
        element: <SignOutPage />,
      },
    ],
  },
  {
    path: "/render/property/:jobId/site-map/:season",
    element: <RenderSiteMap />,
    children: [
      {
        path: "export",
        element: <SiteMapExportPage />,
      },
    ],
  },
  {
    path: "/embed",
    element: <EmbedLayout />,
    errorElement: <ErrorPage />,
    children: [
      {
        path: "/embed/active-routes",
        element: (
          <div className="absolute top-0 bottom-0 left-0 right-0">
            {/* Draws the map */}
            <RequireAppVersion version="2.16.6">
              <ActiveRoutesBaseLayer>
                {/* Supplies the data */}
                <ActiveRouteDataLayer>
                  {/* Draws active crews panel */}
                  <ActiveRoutesEmbedded>
                    <Outlet /> {/* Child route panels */}
                  </ActiveRoutesEmbedded>
                </ActiveRouteDataLayer>
              </ActiveRoutesBaseLayer>
            </RequireAppVersion>
          </div>
        ),
        children: [
          {
            index: true,
            loader: () => redirect("/embed/active-routes/main"),
          },
          {
            element: <Outlet />,
            path: "/embed/active-routes/main",
            children: [
              {
                path: "/embed/active-routes/main/:routeId",
                element: (
                  <>
                    <OverwritingContent>
                      <ActiveRoutesMapRouteDetail />
                    </OverwritingContent>
                    <Outlet />
                  </>
                ),
                children: [
                  {
                    path: "/embed/active-routes/main/:routeId/:propertyId",
                    element: (
                      <OverwritingContent>
                        <ActiveRoutesMapRoutePropertyDetail />
                      </OverwritingContent>
                    ),
                  },
                ],
              },
            ],
          },
        ],
      },
    ],
  },
  {
    path: "/admin",
    element: (
      <PrivateRoutes>
        <AdminWrapper />
      </PrivateRoutes>
    ),
    errorElement: <ErrorPage />,
    children: [
      {
        path: "/admin",
        element: <AdminRoutesPage />,
      },
      {
        path: "/admin/dashboard",
        element: <DashboardPage />,
      },
      {
        path: "/admin/active-routes",
        element: (
          <SubscriptionPaywallV2>
            <ActiveRoutesPage>
              <Outlet />
            </ActiveRoutesPage>
          </SubscriptionPaywallV2>
        ),
        children: [
          {
            index: true,
            loader: () => redirect("/admin/active-routes/main"),
          },
          {
            // this is our layout component
            element: <Outlet />,
            path: "/admin/active-routes/main",
            children: [
              {
                path: "/admin/active-routes/main/crew/:crewId",
                element: (
                  <Sidepanel
                    panelStyle={{ top: "3rem", right: "3rem", zIndex: 20 }}
                    style={{ width: 300, height: 600, background: "#f9f9f9" }}
                  >
                    <CrewDetail />
                  </Sidepanel>
                ),
              },
              {
                path: "/admin/active-routes/main/:routeId",
                element: (
                  <>
                    <Sidepanel
                      panelStyle={{ top: "3rem", right: "3rem", zIndex: 20 }}
                      style={{ width: 300, height: 600, background: "#f9f9f9" }}
                    >
                      <ActiveRoutesMapRouteDetail />
                    </Sidepanel>
                    <Outlet />
                  </>
                ),
                children: [
                  {
                    path: "/admin/active-routes/main/:routeId/:propertyId",
                    element: (
                      <Sidepanel
                        panelStyle={{
                          top: "4.5rem",
                          right: "4.5rem",
                          zIndex: 20,
                        }}
                        style={{
                          width: 300,
                          height: 600,
                          background: "#f6f6f6",
                        }}
                      >
                        <ActiveRoutesMapRoutePropertyDetail />
                      </Sidepanel>
                    ),
                  },
                ],
              },
            ],
          },
        ],
      },
      {
        path: "/admin/active-routes/:routeId",
        element: <ActiveRouteDetailsPage />,
      },
      {
        path: "/admin/account",
        element: <AdminAccountPage />,
      },
      {
        path: "/admin/user/company/create",
        element: <AdminCreateCompanyPage />,
      },
      {
        path: "/admin/user/company/:companyId",
        element: <AdminUpdateCompanyPage />,
      },
      {
        path: "/admin/company/services",
        element: (
          <SubscriptionPaywallV2>
            <AdminUpdateCompanyServicesPage />
          </SubscriptionPaywallV2>
        ),
      },
      {
        path: "/admin/employee",
        element: <AdminEmployeePage />,
      },
      {
        path: "/admin/employee/:id",
        element: <AdminEmployeeDetailsPage />,
      },
      {
        path: "/admin/employee/manage-admins",
        element: <AdminManageAdminsPage />,
      },
      {
        path: "/admin/employee/:id/instructions",
        element: <NewEmployeeInstructionsPage />,
      },
      {
        path: "/admin/material/",
        element: (
          <SubscriptionPaywallV2>
            <AdminMaterialsPage />
          </SubscriptionPaywallV2>
        ),
      },
      {
        path: "/admin/property",
        element: (
          <SubscriptionPaywallV2>
            <AdminJobsPage />
          </SubscriptionPaywallV2>
        ),
      },
      {
        path: "/admin/property/pick",
        element: (
          <SubscriptionPaywallV2>
            <PickAProperty subTitle="Pick a property to view and edit its site map." />
          </SubscriptionPaywallV2>
        ),
      },
      {
        path: "/admin/timeclock",
        element: (
          <SubscriptionPaywallV2>
            <AdminTimeClockPageWrapper />
          </SubscriptionPaywallV2>
        ),
      },
      {
        path: "/admin/timeclock/:record_id",
        element: <TimeRecordPage />,
      },
      {
        path: "/admin/excel_import",
        element: <AdminBulkImportJobs />,
      },
      {
        path: "/admin/property/:jobId",
        element: <EditJobPage />,
      },
      {
        path: "/admin/property/bulk-edit",
        element: <BulkEditJobsPage />,
      },
      {
        path: "/admin/property/share",
        element: <ShareJobsPage />,
      },
      {
        path: "/admin/property/:jobId/merge",
        element: <MergeJobsPage />,
      },
      {
        path: "/admin/property/:jobId/site-map/:season",
        element: <SiteMapIndex />,
        children: [
          {
            index: true,
            element: <SiteMapDefault />,
          },
          {
            path: "export",
            element: <SiteMapExportPage />,
          },
          {
            path: "edit",
            element: <SiteMapEditPage />,
            children: [
              {
                index: true,
                element: <SiteMapEditIndex />,
              },
              {
                path: "setup-boundary",
                element: <SiteMapSetupBoundaryPage />,
              },
              {
                path: "boundary",
                element: <SiteMapBoundaryPage />,
              },
              {
                path: "arrow/:arrowId",
                element: <SiteMapArrowPage />,
              },
              {
                path: "hazard/:hazardId",
                element: <SiteMapHazardPage />,
              },
              {
                path: "surface/:surfaceId",
                element: <SiteMapSurfacePage />,
              },
              {
                path: "text/:textId",
                element: <SiteMapTextPage />,
              },
            ],
          },
          {
            path: "surface/:surfaceId",
            element: <SiteMapSurfacePage />,
          },
        ],
      },
      {
        path: "/admin/property/history",
        element: <AdminJobHistoryPage />,
      },
      {
        path: "/admin/property/history/:jobHistoryId",
        element: <AdminJobHistoryDetailsPage />,
      },
      {
        path: "/admin/property/service-status",
        element: <ServiceStatusPage />,
      },
      {
        path: "/admin/report/",
        element: <AdminReportsPage />,
      },
      {
        path: "/admin/report/service-status",
        loader: () => redirect("/admin/property/service-status"),
      },
      {
        path: "/admin/route",
        element: (
          <SubscriptionPaywallV2>
            <AdminRoutesPage />
          </SubscriptionPaywallV2>
        ),
      },
      {
        path: "/admin/route/create/:season",
        element: <AdminCreateRoutePage />,
      },
      {
        path: "/admin/route/:routeId",
        element: <AdminUpdateRoutePage />,
        children: [
          {
            index: true,
            loader: ({ params, request }) => {
              if (params.routeId === "new") {
                const season = new URL(request.url).searchParams.get("season");
                return redirect(`main?season=${season ?? "snow"}`);
              } else {
                return redirect(`main`);
              }
            },
          },
          {
            path: "/admin/route/:routeId/main",
            element: <IndexRoute />,
            children: [
              {
                path: "/admin/route/:routeId/main/add-jobs",
                element: <AddRoute />,
              },
            ],
          },
          {
            path: "/admin/route/:routeId/preview",
            element: <PreviewRoute />,
          },
          {
            path: "/admin/route/:routeId/optimize",
            element: <OptimizeRoute />,
          },
        ],
      },
      {
        path: "/admin/developer/broadcast-push-notification",
        element: <DeveloperBroadcastPushNotification />,
      },
      {
        path: "/admin/snowscape",
        element: <SnowScapeAdmin />,
      },
      {
        path: "/admin/settings/profile",
        element: <ProfileSettingsPage />,
      },
      {
        path: "/admin/settings/billing",
        element: <AccountPage />,
      },
      {
        path: "/admin/settings/company",
        element: <CompaniesPage />,
      },
      {
        path: "/admin/settings/billing/cancel",
        element: <CancelPage />,
      },
      {
        path: "/admin/debug_snow",
        element: <DebugPage />,
      },
    ],
  },
]);

export default router;
